import t from 'react-translate';
import { mentorCardStyles } from './mentor-card';
import { gray6 } from 'styles/global_defaults/colors';
import { css } from '@emotion/react';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

const ITEM_COUNT = 6;

const loadingPlaceholdersStyles = css`
  .mentor-card-avatar {
    background-color: ${gray6};
  }
  .location-placeholder {
    height: ${threeQuartersSpacing}px;
  }
  .placeholder-bar {
    width: 75%;
  }
  .short-bar {
    width: 50%;
  }
`;

const LoadingPlaceholders = () => {
  const loadingPlaceholders = Array.from({ length: ITEM_COUNT }).map((_, i) => (
    <li key={i} css={loadingPlaceholdersStyles}>
      <div css={mentorCardStyles}>
        <div className='d-flex mentor-card-profile'>
          <div className='mentor-card-avatar' />
          <div className='d-flex flex-column mentor-card-profile-info align-content-center justify-content-center w-100'>
            <div className='loading placeholder-bar short-bar ml-0 mb-2' />
            <div className='location-placeholder loading placeholder-bar ml-0' />
          </div>
        </div>
        <div className='mt-4'>
          <div className='loading placeholder-bar short-bar ml-0' />
          <div className='loading placeholder-bar w-100 ml-0' />
          <div className='loading placeholder-bar w-100 ml-0' />
        </div>
      </div>
    </li>
  ));

  return <>{loadingPlaceholders}</>;
};

export default LoadingPlaceholders;
